import templateUrl from './shiftTemplateSelectionComponent.html';

class ShiftTemplateSelectionCtrl {
  constructor(ShiftUtils, SlingAnalytics, Utils) {
    'ngInject';

    Object.assign(this, { ShiftUtils, SlingAnalytics, Utils });
  }

  $onInit() {
    this.fetchTemplates();
  }

  async fetchTemplates() {
    try {
      this.templatesLoading = true;
      this.templates = await this.ShiftUtils.getFilteredShiftTemplates();
      this.splitTemplatesByUser();
    } catch (e) {
      this.error = this.Utils.getErrorMessages(e);
    } finally {
      this.templatesLoading = false;
    }
  }

  splitTemplatesByUser() {
    this.matchingTemplates = [];
    this.otherTemplates = [];

    if (this.shift.users?.length !== 1) {
      return;
    }

    this.templates.forEach((t) => {
      if (
        this.shift.users[0].locationIds.includes(t.location.id) &&
        this.shift.users[0].positionIds.includes(t.position.id)
      ) {
        this.matchingTemplates.push(t);
      } else {
        this.otherTemplates.push(t);
      }
    });
  }

  async createShiftTemplate() {
    await this.ShiftUtils.openShiftTemplateModal();
    this.templates = await this.ShiftUtils.getFilteredShiftTemplates();
  }

  selectTemplate(template) {
    const shift = { ...template };

    if (shift.taskTemplates?.length) {
      shift.taskTemplates = shift.taskTemplates.map((taskTemplate) => ({ ...taskTemplate }));
    }

    if (this.shift.dtstart) {
      shift.dtstart = this.Utils.setDate(shift.dtstart, this.shift.dtstart);
      shift.dtend = this.Utils.setDate(shift.dtend, this.shift.dtstart);
    }

    this.SlingAnalytics.track(this.SlingAnalytics.analyticsEvents.shiftTemplateUsed);
    this.loadTemplate({ $template: shift });
  }

  cancel() {
    this.modal.dismiss();
  }
}

export default {
  bindings: {
    modal: '<',
    shift: '<',
    loadTemplate: '&',
  },
  templateUrl,
  controllerAs: 'ctrl',
  controller: ShiftTemplateSelectionCtrl,
};
